<template>
  <div>
    <div class="card-header border-0 bg-transparent">
      <div class="row align-items-center">
        <div class="col text-right">
          <button
            class="btn btn-primary text-white btn-sm badge-pill mt-1 mr-3"
            @click="$emit('onPrevPage')"
            v-if="showPrevPageBtn"
          >
            <span>
              <i class="mr-1 fa fa-arrow-left"></i>
              Previous Page
            </span>
          </button>
          <button
            class="btn btn-primary text-white btn-sm badge-pill mt-1 mr-3"
            @click="$emit('onNextPage')"
            v-if="showNextPageBtn"
          >
            <span>
              Next Page
              <i class="ml-1 fa fa-arrow-right"></i>
            </span>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "datatable-footer",
  props: {
    showPrevPageBtn: Boolean,
    showNextPageBtn: Boolean
  }
};
</script>
